import { combineReducers } from "@reduxjs/toolkit";
import { manageContactReducer } from "./Reducers/manageContactReducer";
import purchaseOrderReducer from "./Reducers/purchaseOrderReducer";
import supplierReducer from "./Reducers/supplierReducer";

const rootReducer = combineReducers({
    purchaseOrders: purchaseOrderReducer,
    suppliers: supplierReducer,
    manageContact:manageContactReducer
});

export default rootReducer;